// extracted by mini-css-extract-plugin
export var articleMultipleChoiceCTA = "bL_d8";
export var mainHeader = "bL_fC";